export const CinemaSideNavs = {
  items: [
    {
      name: "لوحة التحكم",
      url: "/MyticketCinema/Cinema-dashboard",
      icon: "fa fa-tachometer-alt",
    },
    {
      name: "الصفحة الشخصية",
      url: "/MyticketCinema/profile",
      icon: "fas fa-user-cog",
    },
    {
      name: "الرصيد",
      url: "/MyticketCinema/CinemaAccounting",
      icon: "fas fa-money-bill-wave",
    },
    {
      name: "تذاكر مُباعة",
      url: "/MyticketCinema/ViewTicketsHistoryCinems",
      icon: "fas fa-ticket-alt",
    },

    {
      name: "كاشير",
      url: "/MyticketCinema/ViewCashier",
      icon: "fas fa-user-tag",
    },
    {
      name: "جميع الأفلام",
      url: "/MyticketCinema/Films",
      icon: "fa fa-film",
    },
    {
      name: "الأفلام بالسينما",
      url: "/MyticketCinema/cinema-Films",
      icon: "fa fa-film",
    },
    {
      name: "فئات التذاكر",
      url: "/MyticketCinema/Tickets",
      icon: "fas fa-eraser",
    },
    {
      name: "القاعات",
      url: "/MyticketCinema/showHalls",
      icon: "fas fa-building ",
    },
    {
      name: "العروض",
      url: "/MyticketCinema/shows",
      icon: "fas fa-images",
    },

    {
      name: "الحجوزات",
      url: "/MyticketCinema/ViewReservationCinema",
      icon: "fas fa-ticket-alt",
    },

    // {
    //     name: "الارشيف",
    //     url: "/MyticketCinema/Archive",
    //     icon: "fa fa-trash-alt",
    // },
    {
      name: "التقارير",
      url: "/MyticketCinema/ReportFilteration",
      icon: "fa fa-file",
    },
  ],
};

export const CinemaSideNavsEn = {
  items: [
    {
      name: "DashBoard",
      url: "/MyticketCinema/Cinema-dashboard",
      icon: "fa fa-tachometer-alt",
    },
    {
      name: "Profile",
      url: "/MyticketCinema/profile",
      icon: "fas fa-user-cog",
    },
    {
      name: "Balance",
      url: "/MyticketCinema/CinemaAccounting",
      icon: "fas fa-money-bill-wave",
    },
    {
      name: "tickets sold out",
      url: "/MyticketCinema/ViewTicketsHistoryCinems",
      icon: "fas fa-ticket-alt",
    },

    {
      name: "Cashier",
      url: "/MyticketCinema/ViewCashier",
      icon: "fas fa-user-tag",
    },
    {
      name: "All Films",
      url: "/MyticketCinema/Films",
      icon: "fa fa-film",
    },
    {
      name: "Cinema's Films",
      url: "/MyticketCinema/cinema-Films",
      icon: "fa fa-film",
    },
    {
      name: "Tickets Category",
      url: "/MyticketCinema/Tickets",
      icon: "fas fa-eraser",
    },
    {
      name: "Halls",
      url: "/MyticketCinema/showHalls",
      icon: "fas fa-building ",
    },
    {
      name: "Show",
      url: "/MyticketCinema/shows",
      icon: "fas fa-images",
    },

    {
      name: "Reservation",
      url: "/MyticketCinema/ViewReservationCinema",
      icon: "fas fa-ticket-alt",
    },

    // {
    //     name: "Archive",
    //     url: "/MyticketCinema/Archive",
    //     icon: "fa fa-trash-alt",
    // },
    {
      name: "Reports",
      url: "/MyticketCinema/ReportFilteration",
      icon: "fa fa-file",
    },
  ],
};
